import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "30",
  fill: "none",
  viewBox: "0 0 31 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M26.69 4.557c-5.61-5.61-14.614-5.741-20.388-.49L4.965 2.73c-.522-.522-1.305-.717-2.022-.522-.718.229-1.273.816-1.403 1.534l-1.5 6.98c-.131.685.065 1.37.554 1.86.49.489 1.174.685 1.86.554l6.98-1.468c.391-.098.75-.293 1.011-.554.229-.229.424-.522.522-.848.196-.718 0-1.5-.522-2.023L9.173 6.971a10.664 10.664 0 0 1 14.614.457c4.175 4.175 4.175 10.96 0 15.135-4.175 4.176-10.96 4.176-15.136 0a10.74 10.74 0 0 1-2.773-4.827c-.293-1.077-1.402-1.73-2.479-1.436-1.076.294-1.729 1.403-1.435 2.48a14.46 14.46 0 0 0 3.85 6.654c5.773 5.774 15.135 5.774 20.909 0 5.708-5.741 5.708-15.136-.033-20.877"
    }, null, -1)
  ]))]))
}
export default { render: render }